window.Vue = require('vue');
import $ from 'jquery';
window._ = require('lodash');
window.v = require('voca');
window.moment = require('moment');
window.$ = window.jQuery = $;
window.UIkit = require('uikit');
//window.moment = require('moment');
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons'
import wait from './components/other/wait'
import DatePicker from 'vue2-datepicker'
import swal from 'sweetalert'
import axios from 'axios';
//import { cf } from './components/mixins/cf'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import 'vue-range-slider/dist/vue-range-slider.css'
require('air-datepicker/dist/js/datepicker.min.js');
import 'air-datepicker/dist/css/datepicker.min.css'
import { bus } from './components/other/bus'

import storage from './components/store/store'

import 'leaflet'
import 'leaflet.markercluster'

moment.locale('ru');

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('D MMMM Y');
    }
});

Vue.use(VueRouter)
Vue.use(Vuex);
Vue.use(DatePicker)

axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';

Vue.filter('cifer', (val) => {
    return val.toLocaleString('ru');
});

//Vue.component('account-register', require('./components/ei/account-register.vue'));
//Vue.component('account-login', require('./components/ei/account-login.vue'));
Vue.component('login', require('./components/mental/login.vue').default);
Vue.component('prepod', require('./components/mental/prepod.vue').default);
Vue.component('student', require('./components/mental/student.vue').default);
Vue.component('help-users-module', require('./components/mental/student/help-data_module.vue').default);
Vue.component('back', require('./components/mental/back.vue').default);
Vue.component('account-restore', require('./components/account-restore.vue').default);
Vue.component('account-reset', require('./components/account-reset.vue').default);
Vue.component('headscores', require('./components/other/headscores').default);
Vue.component('headrating', require('./components/other/headrating').default);
Vue.component('headoutsider', require('./components/mental/prepod/outsider/outsider_headline').default);
Vue.component('crm', require('./components/crm/crm').default);

UIkit.use(Icons);


/* Yandex */
let Yacounter = {
    num: '51115889',
    goal: 'ZAYKA'
};

const store = new Vuex.Store(storage);

const app = new Vue({
    store,
    el: '#app',
    mixins: [
        //cf
    ],
    data: {
        loaded: false,
        prod_qnt: 1,
        wait: false,
        url: init.url,
        modal: {
            title: "Заказать звонок",
            button: 'Отправить',
            theme: 'Заявка',
            vopr: false,
        },

        confid: true,
    },
    computed: {},
    methods: {
        getThemeUrl() {
            return this.url + '/themes/genius/assets/';
        },
        setModal(title = 'Заявка', theme = 'Заявка', button = 'Отправить', vopr = false) {
            let modal = {
                title,
                button,
                theme,
                vopr,
            };
            this.modal = modal;
        },
        counter() {
            if (typeof(window['yaCounter' + Yacounter.num]) !== "undefined") {
                console.log('Счетчик сработал');
                window['yaCounter' + Yacounter.num].reachGoal(Yacounter.goal);
            } else {
                console.log('Счетчик неопределен');
            }
        },
        ajaxes() { 
            this.$on('before-axios', () => this.wait = true);
            bus.$on('before-axios', () => this.wait = true);
      
            bus.$on('after-axios', () => this.wait = false);
            this.$on('after-axios', () => this.wait = false);    
        },
        sendForm(event) {
            let fd = {};
            let form = $(event.target);
            form.serializeArray().forEach(function(element) {
                fd[element.name] = element.value;
            });
            this.wait = true;

            let app = this;
            let formdata = {
                form: fd
            };

            const options = {
                method: 'POST',
                headers: {
                    'X-OCTOBER-REQUEST-HANDLER': 'onSend',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                data: fd,
                url: window.location.href,
            };
            axios(options).then(function(response) {
                console.log(response.data);
                app.counter();
                app.wait = false;
                app.thanks();
            }).catch(function(error) {
                console.log(error);
            });

        },
        thanks() {
            UIkit.modal('#thanksmodal').show();
        },
        getNoun(number, one, two, five) {
            let n = Math.abs(number);
            n %= 100;
            if (n >= 5 && n <= 20) {
                return five;
            }
            n %= 10;
            if (n === 1) {
                return one;
            }
            if (n >= 2 && n <= 4) {
                return two;
            }
            return five;
        },
        maps() {
            /* var map = L.map('mapid').setView([51.505, -0.09], 13);

             L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
               attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
             }).addTo(map);

             L.marker([51.5, -0.09]).addTo(map)
             .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
             .openPopup();*/
            let map = L.map('mapblock').setView([55.796289, 49.108795], 15);

            /*L.tileLayer(
              'http://vec{s}.maps.yandex.net/tiles?l=map&v=4.55.2&z={z}&x={x}&y={y}&scale=2&lang=ru_RU', {
                subdomains: ['01', '02', '03', '04'],
                attribution: '<a http="yandex.ru" target="_blank">Яндекс</a>',
                reuseTiles: true,
                updateWhenIdle: false
              }
            ).addTo(map);*/
            L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
                maxZoom: 20,
                subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
            }).addTo(map);

            //L.marker([55.823292, 49.080758]).addTo(map);
            //L.marker([55.749896, 49.238242]).addTo(map);

            let markers = L.markerClusterGroup();
            markers.addLayer(L.marker([55.823292, 49.080758]).bindPopup('Центр на ул. Ленская, 10'));
            markers.addLayer(L.marker([55.749896, 49.238242]).bindPopup('Центр на ул. Кул Гали, 24'));
            map.addLayer(markers);
            map.fitBounds([
                [55.823292, 49.080758],
                [55.749896, 49.238242]
            ], { padding: [100, 100] });

            //map.setZoom(map.getZoom()-3.6);

            //L.marker([55.79788757, 49.11057300]).addTo(map)
            //.bindPopup('Потолки Esthete')
            //.openPopup();

            map.scrollWheelZoom.disable();

        },
        inits() {

        },
        reRender() {
            this.$forceUpdate();
        }
    },
    components: { DatePicker, wait },
    mounted() {
        this.inits();
        this.ajaxes();

        /*window.onfocus = function (){
          console.log('In focus');
        }*/
    }
});
